<template>
  <div>
    <div v-if="amt != 0">
      <span class="C1">{{ amt }}</span> 元
    </div>
    <div v-else>
      <div v-if="sGetConfig('chkCarHide0Price')"></div>
      <div v-else>
        <span class="C1">{{ amt }}</span> 元
      </div>
    </div>

    <!-- <span class="C1" v-else>{{ amt }}</span>  -->
  </div>
</template>

<script>
export default {
  props: {
    amt: Number,
  },
  data() {
    return {};
  },
  methods: {
    getAmt(pAmt) {
      return pAmt;
    },
  },
};
</script>
